import React, { useState, useEffect } from "react";
import { Alert, Spinner, Fade } from "reactstrap";
import {
  Container,
  BackLink,
  Footer,
  InputCpf,
  ButtonNext,
  ModalCpf,
  Suport
} from "./styles.js";
import api from "../../services/client/api.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useHistory, useLocation } from "react-router-dom"; // Importando o hook useHistory para redirecionamento
import { isCpfValid } from "../../utils/cpfValidate.js";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
function CpfUserCheck() {
  const siteUrl = "https://www.cedap.com.br/duvidas"; // URL do site que será aberto
  const location = useLocation();
  const [cpf_user, setCpf] = useState("");
  const [responseAlert, setResponseAlert] = useState("");
  const history = useHistory(); // Hook para redirecionamento de página
  const [inProgress, setInProgress] = useState(false);
  const { cpf } = location.state || {};
  const [showAlert, setShowAlert] = useState(false);

  const handleClick = () => {
    window.open(siteUrl, "_blank"); // Abre o site em uma nova aba
  };

  useEffect(() => {
    if (responseAlert) {
      setShowAlert(true); // mostra com fade

      const timeout = setTimeout(() => {
        setShowAlert(false); // começa a esconder com fade
        // depois que sumir, limpa o conteúdo
        setTimeout(() => setResponseAlert(""), 700);
      }, 10000);

      return () => clearTimeout(timeout);
    }
  }, [responseAlert]);

  // Preencher o CPF automaticamente no input quando o valor estiver no state
  useEffect(() => {
    if (cpf) {
      setCpf(cpf);
    }
  }, [cpf]); // Esse useEffect roda sempre que o 'cpf' no state mudar

  const handleCpfSubmit = async () => {
    if (inProgress) return; // Evita requisições simultâneas

    setInProgress(true);
    if (cpf) {
      //aqui se existir cpf quero que preencha no input
    }

    if (!isCpfValid(cpf_user)) {
      setResponseAlert("CPF inválido.");
      setInProgress(false);
      return;
    }

    try {
      if (cpf_user) {
        const response = await api()
          .userPatient()
          .VerificarCpf(cpf_user.replace(/\D/g, ""));
        // Verificar se o cpf_user já está cadastrado
        if (response.status === 429) {
          setResponseAlert(
            "Você atingiu o maximo de tentativas de biometria, por favor entre em contato com a equipe de suporte ou compareça a nossa recepção.",
          );
          return;
        }
        if (response.status === 200 && response.output === true) {
          setResponseAlert(
            "Cpf já cadastrado. Informe suas credenciais na página de login.",
          );
          return;
        } else {
          history.replace({
            pathname: "/register",
            state: {
              cpf_user: cpf_user.replace(/\D/g, ""),
            },
          });
        }
      }
    } catch (error) {
      console.error("Erro ao verificar cpf:", error);
      setResponseAlert(
        "Ocorreu um erro ao verificar o cpf, por favor entre em contato com a equipe de suporte.",
      );
      return;
    } finally {
      setInProgress(false); // Libera a requisição após o término
    }
  };

  const handleLoginRedirect = () => {
    history.push("/login"); // Redireciona para a página de login
  };

  const applyCpfMask = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const match = cleanedValue.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
    if (match) {
      return `${match[1]}${match[2] ? "." + match[2] : ""}${match[3] ? "." + match[3] : ""}${match[4] ? "-" + match[4] : ""}`;
    }

    return value;
  };

  const isFormValid = cpf_user.length >= 14;

  return (
    <div>
      <Container>
        {/* Exibe a caixa de cpf_user */}
        <ModalCpf>
          <h4 style={{ fontWeight: 600 }}>Digite seu CPF</h4>
          <InputCpf
            type="text"
            placeholder="Ex: 123.456.789-10"
            value={applyCpfMask(cpf_user)}
            maxLength="14"
            required
            onChange={(e) => setCpf(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && isFormValid && !inProgress) {
                handleCpfSubmit(); // Aciona o botão
              }
            }}
          />
          <ButtonNext onClick={handleCpfSubmit}>
            {inProgress ? <Spinner size="sm" color="light" /> : "Continuar"}
            {!inProgress && (
              <FontAwesomeIcon
                icon={faArrowRight}
                style={{ marginLeft: "10px" }}
              />
            )}
          </ButtonNext>
          {responseAlert && (
            <>
              {showAlert && (
                <Fade in={showAlert} timeout={600}>
                  <Alert style={{ marginTop: "10px" }} color="danger">
                    {responseAlert}
                  </Alert>
                </Fade>
              )}
            </>
          )}
          <BackLink onClick={handleLoginRedirect}>
            <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 3 }} />{" "}
            Voltar
          </BackLink>
        </ModalCpf>
      </Container>
      <Footer>
        Precisa de ajuda? Confira as{""}
        <button
          onClick={handleClick}
          style={{
            border: "none",
            background: "none",
            cursor: "pointer",
            color: "#007bff",
          }}
        >
          <strong>Perguntas Frequentes.</strong>
        </button>
      </Footer>
       <Suport href="https://wa.me/5547991153595" target="_blank">
              <u>Suporte</u>
              <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
            </Suport>
    </div>
    
  );
}

export default CpfUserCheck;
